import { styled } from '@mui/material/styles';

/** The visible swatch; the native picker sits invisibly on top so clicking it opens the picker. */
export const ColorSwatch = styled('label', {
  shouldForwardProp: prop => prop !== 'color' && prop !== 'disabled',
})<{ color: string; disabled: boolean }>(({ theme, color, disabled }) => ({
  position: 'relative',
  width: 24,
  height: 24,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.grey[400]}`,
  backgroundColor: color,
  cursor: disabled ? 'default' : 'pointer',
  overflow: 'hidden',
}));

export const ColorSwatchNativeInput = styled('input')({
  position: 'absolute',
  inset: 0,
  opacity: 0,
  cursor: 'inherit',
});
